import { Table } from '@components/ui';
import styled from 'styled-components';

export const TableSC = styled(Table)`
  table td:last-child {
    text-align: right;
  }
` as typeof Table;
